import { PAGES } from 'src/constants/pages';
import { getCompanyWorkspacesHelper } from 'src/redux/sagas/sagaHelpers/workspacesApiHelpers';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';
import { getCurrentWorkspaceFromLocalStorage } from 'src/utils/comon';

export const redirectHandler = async (
  role: ACCOUNT_ROLES,
  email: string,
  push: (path: string) => void
): Promise<void> => {
  const isCompanyRole = role === ACCOUNT_ROLES.COMPANY;
  const isUserRole = role === ACCOUNT_ROLES.USER;

  if (isCompanyRole) {
    try {
      const response = await getCompanyWorkspacesHelper();
      const freshWorkspaces = response?.data?.data || [];

      if (freshWorkspaces && Array.isArray(freshWorkspaces) && freshWorkspaces.length > 0) {
        push(PAGES.WORKSPACES_MANAGEMENT);
      } else {
        push(PAGES.WORKSPACES_CREATE);
      }
    } catch (error) {
      console.error('Error fetching workspaces:', error);
      push(PAGES.WORKSPACES_CREATE);
    }
    return;
  }

  if (isUserRole) {
    const savedWorkspase = getCurrentWorkspaceFromLocalStorage(email);

    savedWorkspase ? push(PAGES.DASHBOARD) : push(PAGES.WORKSPACES_CHOOSE);
    return;
  }

  push(PAGES.HOME);
};
